import React from "react";
import { Navigate } from "react-router-dom";
import { Storage } from "../services/storage/storage";
import { apiService } from "../services/api";


const auth = Storage.getUserToken();
apiService.setUserToken(auth);

const PrivateRoute = ({ component: Component, ...rest }) =>
  auth ? <Component {...rest} /> : <Navigate to={`${process.env.PUBLIC_URL}/auth-login`} replace />;

export default PrivateRoute;
